import { useEffect, useState } from 'react'
import { getFilterForColors } from '~/utils/style/getFilterForHex'

export const useStarFilter = (
  productId,
  inline = false,
  colorMode,
  shopAll = false,
) => {
  const [starFilter, setStarFilter] = useState('')

  useEffect(() => {
    setStarFilter(
      getFilterForColors(
        colorMode,
        inline ? '--theme-ui-colors-primary' : '--theme-ui-colors-tertiary',
      ),
    )
  }, [productId, inline, colorMode, shopAll])

  return starFilter
}
